import { useContext } from 'react';
import { useIntl } from 'react-intl';

import Poll from '@/components/polls/Poll';
import { PreSignupFlowContext } from '@/components/PreSignupFlow/PreSignupProvider';
import { useAnalytics } from '@/hooks/analytics';

import { getChoicesFromTiles, onSelectChoice } from '../utils';

interface Props {
	compact?: boolean;
}

const PollWithResponse = ({ compact }: Props) => {
	const { formatMessage } = useIntl();
	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { questionType, isSelectedScreen, createResponse, tiles, question } = ActiveScreen;
	const { logEvent, logEventAsync } = useAnalytics();

	// const pollScreenName = activeScreen.includes('Selected')
	// 	? activeScreen.replace('Selected', '')
	// 	: activeScreen;

	async function _onSelectChoice(choiceId: string): Promise<void> {
		// No selecting from the selected screen
		if (isSelectedScreen) {
			return;
		}
		const selectedTile = tiles?.find(tile => tile.id === choiceId);
		if (!selectedTile) {
			return;
		}
		await onSelectChoice(choiceId, questionType, logEventAsync);
		nextScreen();
	}

	async function onComplete(choiceIds: string[]): Promise<void> {
		logEvent({
			eventName: 'FTUE : Intro Questions : Proceeded',
			eventProps: {
				choices: choiceIds,
				num_choices: choiceIds.length,
				question_type: questionType as string,
			},
		});
		nextScreen();
	}

	return (
		<Poll
			title={question && formatMessage(question)}
			choices={getChoicesFromTiles(tiles, formatMessage)}
			onSelectChoice={_onSelectChoice}
			onComplete={onComplete}
			compact={compact}
			renderChoiceResponse={choiceIds => {
				const selectedTile = tiles?.find(tile => tile.id === choiceIds[0]);
				return createResponse?.(selectedTile, formatMessage) ?? null;
			}}
		/>
	);
};
export default PollWithResponse;
